<template>
  <v-card raised>
    <v-toolbar flat class="pt-4">
      <v-toolbar-title class="font-weight-bold display-1" v-if="title">{{ title }}</v-toolbar-title>
      <div class="flex-grow-1 "></div>
      <v-text-field
        v-if="searchable"
        rounded
        :value="search"
        @input="searchResults"
        outlined
        solo
        single-line
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        :height="10"
        clearable
        class="hidden-sm-and-down"
      ></v-text-field>

      <div class="flex-grow-1"></div>

      <slot name="action.icons"> </slot>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      disable-sort
      :options.sync="options"
      @click:row="$emit('click:row', $event)"
      :server-items-length="totalItemsCount"
      fixed-header
      v-bind="$attrs"
      :footer-props="footerProps"
    >
      <v-progress-linear slot="progress" active indeterminate stripped :height="6" />
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"
        ><slot :name="name" v-bind="slotData"
      /></template>
    </v-data-table>
  </v-card>
</template>
<script>
import get from 'lodash/get';
import debounce from 'lodash/debounce';
export default {
  props: {
    headers: { required: true, type: Array },
    paginated: { default: true },
    searchable: { default: false, type: Boolean },
    sortBy: { default: () => [], type: [Array, String] },
    url: { required: true },
    title: { type: String },
    footerProps: {
      default() {
        return { itemsPerPageOptions: [50, 100, 200] };
      },
    },
  },

  data() {
    return {
      loading: true,
      items: [],
      totalItemsCount: 0,
      search: '',
      options: {
        sortBy: this.sortBy,
      },
    };
  },
  methods: {
    fetchData(page = 1) {
      this.loading = true;
      this.$http
        .get(this.url, {
          params: { page, per_page: this.options.itemsPerPage, search: this.search },
        })
        .then(response => {
          if (this.paginated) {
            return this.setPaginationResults(response);
          }
          this.items = response;
        })
        .catch(({ response }) => {
          const message = get(
            response,
            'data.message',
            'Something went wrong while fetching table data',
          );
          Notify.warning(message);
        })
        .finally(() => (this.loading = false));
    },
    setPaginationResults(results) {
      const { data, total } = results;
      this.items = data;
      this.totalItemsCount = total;
    },
    debounedSearch: debounce(function(vm, search) {
      vm.fetchData({ search });
    }, 500),
    searchResults(value) {
      this.search = value;
      this.debounedSearch(this, value);
    },
  },
  watch: {
    options(options) {
      this.fetchData(options.page);
    },
  },
};
</script>
<style lang="scss">
.v-data-table__wrapper {
  td {
    cursor: pointer;
  }
}
</style>
